// extracted by mini-css-extract-plugin
module.exports = {"icon":"zFdmp2","spin":"QfnyIj","scribble":"hGW_zZ"};